import { AnimationButton } from "../../components/Animation";

const Contact = () => {
  return (
    <section
      className="framer-gga7ze"
      data-framer-name="Contact"
      id="contact"
      data-name="Contact"
    >
      <div className="framer-yvfhgs">
        <div className="framer-x5t36e" data-framer-name="Text" data-name="Text">
          <div
            className="framer-3roo8m flex flex-col justify-start flex-shrink-0 transform-none"
            data-framer-component-type="RichTextContainer"
          >
            <h2
              className="framer-text framer-styles-preset-15mg8bp"
              data-styles-preset="IXKxaceG9"
            >
              <span
                data-text-fill="true"
                className="framer-text bg-gradient-to-r from-white to-[#70b2fa]"
              >
                Let's talk!
              </span>
            </h2>
          </div>
          <div
            className="framer-1eeuq8g"
            data-framer-name="Company Info"
            data-name="Company Info"
          >
            <div
              className="framer-1hiy7cj"
              data-framer-name="Adress"
              data-name="Adress"
            >
              <div
                className="framer-10yitai flex flex-col justify-start flex-shrink-0 transform-none"
                data-framer-component-type="RichTextContainer"
              >
                <p className="framer-text text-white text-[15px] font-[Switzer, sans-serif] tracking-[0px]">
                  <span
                    data-text-fill="true"
                    className="framer-text bg-gradient-to-r from-white to-[#70b2fa]"
                  >
                    Office:
                  </span>
                </p>
              </div>
              <div
                className="framer-qw0owr"
                data-framer-name="Adress"
                data-name="Adress"
              >
                <div
                  className="framer-uvqbjo flex flex-col justify-start flex-shrink-0 transform-none"
                  data-framer-component-type="RichTextContainer"
                >
                  <p
                    className="framer-text framer-styles-preset-85tvh7"
                    data-styles-preset="FhU5qX9WL"
                  >
                    Menlo Park
                    <br className="framer-text" />
                    CA 9402
                    <br className="framer-text" />
                    United States
                  </p>
                </div>
              </div>
            </div>
            <div
              className="framer-1omc4jd"
              data-framer-name="Line"
              data-name="Line"
            ></div>
            <div
              className="framer-cm80vv"
              data-framer-name="Email"
              data-name="Email"
            >
              <div
                className="framer-gzy51t flex flex-col justify-start flex-shrink-0 transform-none"
                data-framer-component-type="RichTextContainer"
              >
                <p className="framer-text text-white text-[15px] font-[Switzer, sans-serif] tracking-[0px]">
                  <span
                    data-text-fill="true"
                    className="framer-text bg-gradient-to-r from-white to-[#70b2fa]"
                  >
                    Media:
                  </span>
                </p>
              </div>
              <div className="framer-1fz61wk-container !w-full !h-[20px]">
                <a
                  className="framer-AOsUx framer-NrkXy framer-b8oikg framer-v-b8oikg framer-962nx5 !w-[300px] !h-[20px]"
                  data-framer-name="Button Email"
                  href="/cdn-cgi/l/email-protection#11787f777e51657462653f727e7c"
                  target="_blank"
                  rel="noopener"
                >
                  <div
                    className="framer-10ach0s flex flex-col justify-start flex-shrink-0 transform !left-0 -translate-y-1/2"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h3
                      className="framer-text framer-styles-preset-6ghdir !text-[16px]"
                      data-styles-preset="E4lBliITk"
                    >
                      <span
                        className="__cf_email__"
                        data-cfemail="2d44434b426d454c4142034e4240"
                      >
                        press@codeblaze.ai
                      </span>
                    </h3>
                  </div>
                  <div
                    className="framer-10ldvoj flex flex-col justify-start flex-shrink-0 transform -translate-x-1/2"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h3
                      className="framer-text framer-styles-preset-6ghdir"
                      data-styles-preset="E4lBliITk"
                    >
                      <span
                        className="__cf_email__"
                        data-cfemail="0a63646c654a626b666524696567"
                      >
                        info.com
                      </span>
                    </h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          className="framer-k9jwxq"
          data-framer-name="Contact Form"
          data-name="Contact Form"
        >
          <form className="framer-5u0143">
            <label
              className="framer-1kz3kwl"
              data-framer-name="Name"
              data-name="Name"
            >
              <div
                className="framer-p7xk68 flex flex-col justify-start flex-shrink-0"
                data-framer-component-type="RichTextContainer"
              >
                <h4
                  className="framer-text framer-styles-preset-1nt88v3 !text-white"
                  data-styles-preset="e67rss72C"
                >
                  Name
                </h4>
              </div>
              <div className="framer-form-text-input framer-form-input-wrapper framer-1a4lfgn">
                <input
                  type="text"
                  required
                  data-name="Name"
                  placeholder="John Doe"
                  className="framer-form-input framer-form-input-empty"
                />
              </div>
            </label>
            <label
              className="framer-1mv449a"
              data-framer-name="Email"
              data-name="Email"
            >
              <div
                className="framer-nopjb9 flex flex-col justify-start flex-shrink-0"
                data-framer-component-type="RichTextContainer"
              >
                <h4
                  className="framer-text framer-styles-preset-1nt88v3 !text-white"
                  data-styles-preset="e67rss72C"
                >
                  Email
                </h4>
              </div>
              <div className="framer-form-text-input framer-form-input-wrapper framer-1ph2abo">
                <input
                  type="email"
                  data-name="Email"
                  placeholder="john@example.com"
                  className="framer-form-input framer-form-input-empty"
                />
              </div>
            </label>
            <label
              className="framer-1djs6hx"
              data-framer-name="Phone"
              data-name="Phone"
            >
              <div
                className="framer-j04qdw flex flex-col justify-start flex-shrink-0"
                data-framer-component-type="RichTextContainer"
              >
                <h4
                  className="framer-text framer-styles-preset-1nt88v3 !text-white"
                  data-styles-preset="e67rss72C"
                >
                  Phone
                </h4>
              </div>
              <div className="framer-form-text-input framer-form-input-wrapper framer-7j7enf">
                <input
                  type="tel"
                  required
                  data-name="Phone"
                  placeholder="+1 555 1234 123"
                  className="framer-form-input framer-form-input-empty"
                />
              </div>
            </label>
            <label
              className="framer-j5z4b9"
              data-framer-name="Message"
              data-name="Message"
            >
              <div
                className="framer-1soxzt1 flex flex-col justify-start flex-shrink-0"
                data-framer-component-type="RichTextContainer"
              >
                <h4
                  className="framer-text framer-styles-preset-1nt88v3 !text-white"
                  data-styles-preset="e67rss72C"
                >
                  Message
                </h4>
              </div>
              <div className="framer-form-text-input framer-form-input-wrapper framer-jojokm">
                <textarea
                  required
                  data-name="Message"
                  placeholder="Hi codeblaze team! I'm reaching out for..."
                  className="framer-form-input"
                ></textarea>
              </div>
            </label>
            <div className="framer-wlm6qx-container">
              <AnimationButton>
                <button
                  type="submit"
                  className="framer-gWCwD framer-1gjtrw7 framer-v-1gjtrw7 bg-[var(--token-dfd29766-9b54-40dd-9398-e62b74c1aefb,rgb(34,34,34))] rounded-[10px] !w-full opacity-100"
                  data-framer-name="Default 1"
                  data-highlight="true"
                  data-reset="button"
                  tabIndex={0}
                >
                  <div
                    className="framer-2rjhaj outline-none flex flex-col justify-start flex-shrink-0"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text text-[14px] tracking-[0px]">
                      <span
                        data-text-fill="true"
                        className="framer-text bg-gradient-to-r from-[rgb(255,255,255)] to-[rgb(112,190,250)]"
                      >
                        Submit
                      </span>
                    </p>
                  </div>
                  <div
                    className="framer-14bqof7 bg-[rgb(22,22,22)] rounded-[8px]"
                    data-framer-name="Fill"
                  ></div>
                </button>
              </AnimationButton>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
